/**
 * Google Play / OBS content capture — same popup size as
 * `/prototype/mobile/sliding/recording/feature-graphic` (PrototypeMain 1920×1080).
 */
export const RECORDING_FRAME_GOOGLE_1080P = {
    width: 1920,
    height: 1080,
    kind: "google-1080p",
};
